<template>

    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="tasks" class="m-2"></b-icon>
                Plan de financement
            </p>
        </header>
        <section class="modal-card-body">

            <div class="has-text-centered">

                <h1 class="title">Plan de financement du projet {{ detailProject.project }}</h1>

                <hr>

                <b-field label="Copier le tableau dans votre presse-papier">
                    <b-switch v-model="isSpreadsheet"
                              @input="copy()">
                        Reformater les nombres et copier le tableau
                    </b-switch>
                </b-field>


                <hr>

                <b-table
                        :data="data"
                        :columns="columns"
                        hoverable
                        centered="false">
                </b-table>

            </div>

        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Quitter
            </button>
        </footer>



    </div>
</template>

<script>

    export default {
        name: "DetailProject",
        props: {
            detailProject: {
                type: Object,
                required: true
            },
        },
        computed: {},
        mounted() {
            // console.log(this.detailProject)
            this.makeTable();
        },
        methods: {
            async copy() {
                await this.makeTable();
                if (this.isSpreadsheet) {
                    console.log('copié!')
                    let range = document.createRange();
                    let containerNode = this.$el.querySelector('table')
                    console.log(containerNode)
                    range.selectNode(containerNode); //// this part
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                    document.execCommand("copy");
                    window.getSelection().removeAllRanges();
                    this.$buefy.snackbar.open({
                        message: `Tableau copié dans votre presse-papier !`,
                        position: 'is-top',
                    });
                }
            },
            makeTable() {
                // Init table
                this.data = [];
                this.columns = [
                    {
                        field: 'label',
                        label: 'Phases',
                        centered: true
                    },
                    {
                        field: 'sum',
                        label: 'Coût du projet',
                        centered: true
                    },
                ];

                // Extract columns (financeurs) for each phase
                this.detailProject.synth.forEach(s => {
                    s.fi.forEach(f => {
                        this.columns.push( { field: f.fi, label: f.fi, centered: true} )
                    })
                })
                // Remove duplicated columns
                this.columns = this.columns.filter((v,i,a)=>a.findIndex(t=>(t.field === v.field))===i)
                let sums = {}
                this.detailProject.synth.forEach(s => {
                    let t = {};
                    // Generic infos per row
                    t.label = s.ProjectPhase;
                    t.sum = this.addSpace(this.roundTwoDigits(s.ProjectCost, 2), this.isSpreadsheet);
                    s.fi.forEach(f => {
                        t[f.fi] = `${this.addSpace(this.roundTwoDigits(f.cost, 2), this.isSpreadsheet)} ( ${ this.roundTwoDigits( (f.cost / s.ProjectCost) * 100, 2) } %)`;
                        if (sums[f.fi] !== undefined) {
                            sums[f.fi] += f.cost
                        } else {
                            sums[f.fi] = f.cost
                        }
                    })
                    this.data.push(t)
                })
                // Round and space
                for (let key in sums) {
                    sums[key] = this.addSpace(this.roundTwoDigits(sums[key], 2), this.isSpreadsheet);
                }

                // Push to data table
                sums['sum'] = this.addSpace(this.roundTwoDigits(this.detailProject.ProjectCost, 2), this.isSpreadsheet);
                this.data.push(sums)
            }
        },
        data() {
            return {
                isSpreadsheet: false,
                columns: [],
                data: [],
            }
        },
    }
</script>

<style scoped>

</style>
